/**
 * Утилита для форматирования номера телефона.
 * 
 * formatPhone — принимает строку, возвращает номер в маске +7 (XXX) XXX-XX-XX.
 * Применяется: ClientEditModal в Diagnostic,
 *              ClientEditModal в Master,
 *              OrderModal в Master
 */

export function formatPhone(value) {
    let digits = value.replace(/\D/g, '')
    if (digits.length > 0 && digits[0] !== '7' && digits[0] !== '8') digits = `7${digits}`
    if (digits.startsWith('8')) digits = `7${digits.slice(1)}`
    digits = digits.slice(0, 11)
    if (digits.length === 0) return ''
    if (digits.length <= 1) return '+7'
    if (digits.length <= 4) return `+7 (${digits.slice(1)}`
    if (digits.length <= 7) return `+7 (${digits.slice(1, 4)}) ${digits.slice(4)}`
    if (digits.length <= 9) return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
    return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`
}
